<footer class="main-footer">
  <div class="container-dynamic d-flex">
    <span class="m-auto"></span>
    Copyrights 2021
  </div>
</footer>
